










import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class Icon extends Vue {
	@Prop({default: () => ([])}) readonly classes!: Array<string>;
	@Prop({required: false, default: null}) readonly name: string;
	@Prop({required: false}) readonly url: string;
	@Prop({default: null}) readonly variant: string | null;
	@Prop({default: null}) readonly onClick?: Function | null;

	cache: Map<string, string> = new Map();

	$refs: { icon: HTMLElement };

	get clickHandler(): Function {
		return this.onClick ? this.onClick : () => ({});
	}

	get dataSvg(): string {
		let iconName: string = this.name || 'ui/layers';

		if (!iconName) {
			return '';
		}

		if (iconName.indexOf('http') > -1) {
			return iconName;
		} else {

			return require(`@/icons/${iconName}.svg`);
		}
	}

	@Watch('name')
	async onNameChanged(newName: string): Promise<void> {
		await this.fetchIcon(newName);
	}

	async mounted(): Promise<void> {
		if (typeof window === 'undefined') {
			return;
		}

		await this.fetchIcon();
	}

	async fetchIcon(name: string | null = null): Promise<void> {
		let iconName: string = (name || this.name) ? name || this.name : 'ui/layers';

		try {

			if (iconName.indexOf('http') > -1) {
				iconName = `icon-${Math.random()}`;
				await this.cache.set(iconName, await fetch(`${this.name}`).then((icon: any) => icon.text()));
			} else if (iconName) {
				await this.cache.set(iconName, await fetch(`${serverVariables.httpRequest.basePath}${process.env.ASSET_BASE}/frontend/icons/${iconName}.svg`).then((icon: any) => icon.text()));
			}

		} catch (error) {
			await this.cache.delete(iconName);
		}

		if (this.cache.has(iconName) && this.$refs.icon) {
			this.$refs.icon.innerHTML = await this.cache.get(iconName) || '';
		}
	}
}
